export const buildNotificationEventKey = (notification = {}) => {
  const title = notification.title || "notification";
  const body = notification.body || notification.message || "";

  if (notification.bookingRequestId) {
    return `booking:${notification.bookingRequestId}::${title}::${body}`;
  }

  return `${title}::${body}`;
};

export const shouldShowBrowserNotification = (isDocumentHidden) =>
  true;

export const shouldShowToastNotification = (isDocumentHidden) =>
  !isDocumentHidden;
